import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import type { CtaExposures } from "@/components/custom/CtaButton/CTAButtonPersonalized";
import { SingleImage } from "@/components/custom/SingleImage";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import type { TypeButtonSkeleton, TypeExternalButtonSkeleton, TypeImageSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import HeroContent from "./HeroContent";
type ButtonLike = Entry<TypeButtonSkeleton | TypeExternalButtonSkeleton, undefined, string> | UnresolvedLink<"Entry">;
interface Props {
  heading: string;
  subheading: string;
  cta: ButtonLike[];
  ctaExposures?: CtaExposures;
  isShowReviews: boolean;
  image: Entry<TypeImageSkeleton, undefined, string> | UnresolvedLink<"Entry">;
  layout: "Image left" | "Image right";
  reviews?: React.ReactNode;
}
export default function HeroLayout(t0) {
  const $ = _c(25);
  const {
    heading,
    subheading,
    cta,
    ctaExposures,
    image,
    layout,
    reviews
  } = t0;
  let imageEntry;
  let t1;
  if ($[0] !== image) {
    imageEntry = getEntryOfContentType(image, "image");
    t1 = imageEntry ? ContentfulHelper.parseContentfulContentImage(imageEntry.fields.media) : null;
    $[0] = image;
    $[1] = imageEntry;
    $[2] = t1;
  } else {
    imageEntry = $[1];
    t1 = $[2];
  }
  const contentImage = t1;
  const isImageLeft = layout === "Image left";
  const t2 = !isImageLeft && "lg:order-last";
  let t3;
  if ($[3] !== t2) {
    t3 = cn(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== contentImage || $[6] !== imageEntry?.sys) {
    t4 = contentImage && <SingleImage image={contentImage} entryId={imageEntry?.sys.id} priority={true} sizes="(min-width: 548px) 500px, 100vw" />;
    $[5] = contentImage;
    $[6] = imageEntry?.sys;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = !isImageLeft && "lg:order-first";
  let t7;
  if ($[11] !== t6) {
    t7 = cn("flex flex-col justify-center items-start px-3 max-w-125 mx-auto w-full", t6);
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== cta || $[14] !== ctaExposures || $[15] !== heading || $[16] !== reviews || $[17] !== subheading) {
    t8 = <HeroContent heading={heading} subheading={subheading} cta={cta} ctaExposures={ctaExposures} reviews={reviews} />;
    $[13] = cta;
    $[14] = ctaExposures;
    $[15] = heading;
    $[16] = reviews;
    $[17] = subheading;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t9) {
    t10 = <section className="flex items-center justify-center w-full max-w-site-content mx-auto px-6 py-6"><div className="grid w-full grid-cols-1 lg:grid-cols-2 gap-6 items-center">{t5}{t9}</div></section>;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}